import React, {useState } from 'react'
import "./navbarXLarge.css"
import "./navbar.css"
import "./navbarMedium.css" 
import "./navbarSmall.css"
import "./navbarXSmall.css"
import {RxCross1} from 'react-icons/rx'
import {FaHamburger} from 'react-icons/fa'

const Navbar = () => {
// Burger menu
const [OpenMenu, setOpenMenu] = useState(false);

  //ON SCROLL NAVBAR
  const [isScroll, setIsScroll] = useState(false)

window.addEventListener('scroll', () => {
    if (window.scrollY > 200 ) {
      setIsScroll(true)
    } else if (window.scrollY <= 200) {
      setIsScroll(false);
      setOpenMenu(false);
    }
});

  return (
      <>
        <header className={`${isScroll ? 'show' : "" }`}>
            <h2 className="logo">
              <a href='#hero'>LUCA</a>
            </h2>
            <nav className="navigation">
                <a href="#work">Projects</a>
                <a href="#about">About</a>
                <a href="#contact">Contact</a>
            </nav>
            <div className='responsive-nav'>
              <button id="open__nav-btn" className={`${OpenMenu ? 'nodisplay open__nav-btn' : "open__nav-btn" }`} onClick={() => setOpenMenu(true)}>
                <FaHamburger/>
              </button>
              <button id="close__nav-btn" className={`${OpenMenu ? 'close__nav-btn' : " close__nav-btn nodisplay" }`} onClick={() => setOpenMenu(false)}>
                  <RxCross1/>
              </button>
            </div>
        </header>

        <ul id="nav__items" className={`${OpenMenu ? 'nav__items' : "hidden nav__items nodisplay" }`}>
          <li>
              <a href="#work" onClick={() => setOpenMenu(false)}>Projects</a>
          </li>
          <li>
              <a href="#about" onClick={() => setOpenMenu(false)}>About</a>
          </li>
          <li>
              <a href="#contact" onClick={() => setOpenMenu(false)}>Contact</a>
          </li>
          <li className='btn-border'>
              <a href="mailto:hochedezluca@proton.me?subject=Let's Connect" className='nav-btn' onClick={() => setOpenMenu(false)}>Hire me</a>
          </li>
        </ul>
      </>
  )
}

export default Navbar